import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index';

import axios from './util/http'
import * as orignAxios from 'axios'

// 公共样式和方法
import './assets/js/base'
import "./assets/js/global";
// 引入的内诊系统的公共样式
import '@/assets/css/common/common.less'
import '@/assets/css/color.less'
import '@/assets/css/theme.less'
import '@/assets/css/main.css'

// qs异步转码
import qs from 'qs';
Vue.prototype.$qs = qs;


//获取配置
// import { getConfigFn } from './util/setConfig'
// Vue.prototype.$getConfigFn = getConfigFn
// element-ui
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI, { size: 'small' })

// echart
import VCharts from 'v-charts'
Vue.use(VCharts)


// 引入Echarts
import Echarts from 'echarts'
Vue.prototype.echarts = Echarts
Vue.use(Echarts)


// 富文本编辑器
import  VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import moment from 'moment'
Vue.prototype.$moment = moment;

Vue.use(VueQuillEditor)


//打印
import Print from 'vue-print-nb'
Vue.use(Print);  //注册

// uploader
import uploader from 'vue-simple-uploader'
Vue.use(uploader)
//调试工具
// import Vconsole from 'vconsole';
// const vConsole = new Vconsole()
// Vue.use(vConsole)
// Vue.prototype.$baseUrl = 'http://172.18.0.16:9999'

// 添加全局事件监控方法
Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'url') {
      // 创建一个StorageEvent事件
      var newStorageEvent = document.createEvent('StorageEvent');
      const storage = {
          setItem: function (k, val) {
              localStorage.setItem(k, val);
              // 初始化创建的事件
              newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
              // 派发对象
              window.dispatchEvent(newStorageEvent)
          }
      };
      return storage.setItem(key, newVal);
  }
};

Vue.prototype.$axios = axios;

Vue.prototype.$Get = function (_url, _params, _successFunction, dom) {
  axios.get(_url, {params: _params})
      .then((response) => {
          return _successFunction(response.data);
      }).catch(error => {
  })
};
Vue.prototype.$Put = function (_url, _params, _successFunction, dom, stringfy) {
  var mparams = stringfy ? qs.stringify(_params, {indices: false}) : _params;
  axios.put(_url, mparams)
      .then((response) => {
          return _successFunction(response.data)
      }).catch(error => {
  })
};
Vue.prototype.$Delete = function (_url, _params, _successFunction, dom) {
  axios.delete(_url, {params: _params})
      .then((response) => {
          return _successFunction(response.data)
      }).catch(error => {
  })

};
Vue.prototype.$DeleteData = function (_url, _params, _successFunction, dom) {
  axios.delete(_url, {data: _params})
      .then((response) => {
          return _successFunction(response.data)
      }).catch(error => {
  })

};
Vue.prototype.$Post = function (_url, _params, _successFunction, dom, stringfy) {
  var mparams = stringfy ? qs.stringify(_params, {indices: false}) : _params;
  axios.post(_url, mparams)
      .then((response) => {
          return _successFunction(response.data);
      }).catch(error => {
      return _successFunction(error)
  })
};

// 文件上传, 整个文件上传
Vue.prototype.$Upload = function (_url, _params, _files, _successfunction, dom) {
  let formData = new FormData();
  let config = {
      headers: {
          //'Content-Type': 'multipart/form-data;boundary=---------------' + new Date().getTime(),
          'Authorization': `Bearer ${store.getters.access_token}`,
          'Content-Type': 'multipart/form-data'
      }
  };
  if (_params) {
      for (var x in _params) {
          formData.append(x, _params[x]);
      }
  }
  if (_files) {
      _files.forEach((e, index) => {
          formData.append("file[" + (index + 1) + "]", e);
      })
  }

  orignAxios.post(_url, formData, config).then(resp => {
      return _successfunction(resp.data);
  }).catch(error => {
      return _successfunction(error)
  });

};



// 文件切片上传
/**
* 文件切片上传
* @param _url 上传地址
* @param _params  上传参数
* @param _file    上传文件
* @param _fileid  上传文件id
* @param _startindex 开始切片
* @param _progress    进度方法function(total, current)
* @param _successfinish 成功后回调
* @param _fail          失败后回调
*
* */

Vue.prototype.$ChunkUpload = function (_url, _params, _file, _fileid, _startindex, _progress, _successfinish, _fail) {

  var fileslice = [];

  var rejectFlag = false;

  var uploadindex = 0;

  // debugger
  if (_file.size > chunkSize) {
      var chunk = _file.size % chunkSize > 0 ? Math.ceil(_file.size / chunkSize) : Math.floor(_file.size / chunkSize);
      var readchunksize = 0;
      for (let i = 0; i < chunk; i++) {
          if (readchunksize + chunkSize > _file.size) {
              fileslice.push(_file.slice(readchunksize, _file.size));
          } else {
              fileslice.push(_file.slice(readchunksize, readchunksize + chunkSize));
          }

          readchunksize += chunkSize;

      }


  } else {
      fileslice.push(_file);
  }


  var chunkupload = (chunkslice, index) => {

      let config = {
          headers: {
              //'Content-Type': 'multipart/form-data;boundary=---------------' + new Date().getTime(),
              'Authorization': `Bearer ${store.getters.access_token}`,
              'Content-Type': 'multipart/form-data'
          },
          timeout: 1000 * 60 * 2
      };

      let formData = new FormData();
      if (!NeizhenUtil.isEmpty(_params)) {
          for (var x in _params) {
              formData.append(x, _params[x]);
          }
      }
      formData.append("randomName", _fileid);
      formData.append("chunk", index);
      formData.append("file", chunkslice);
      return new Promise((resolve, reject) => {

          orignAxios.post(_url, formData, config).then(resp => {
              if (resp.data) {
                  uploadindex++;
                  if (NeizhenUtil.isFunction(_progress)) {
                      _progress.call(this, fileslice.length, uploadindex);
                  }

                  resolve(resp.data);
              } else {
                  _fail.call(this, _fileid, index);
                  reject(resp.data);
              }

          }).catch(error => {
              _fail.call(this, _fileid, index);
              reject(error);

          });

      });

  };

  // debugger

  var mall = [];
  var finishchunk = false;
  for (let i = _startindex; i < fileslice.length; i++) {

      finishchunk = false;
      var p = chunkupload(fileslice[i], i);
      mall.push(p);

  }

  orignAxios.all(mall).then((resolve) => {
      _successfinish.call(this, _fileid);
  }).catch((error) => {

  });
};
Vue.prototype.$ChunkUploadGet = function (_url, _params) {


  let config = {
      headers: {
          //'Content-Type': 'multipart/form-data;boundary=---------------' + new Date().getTime(),
          'Authorization': `Bearer ${store.getters.access_token}`,
          'Content-Type': 'multipart/form-data'
      },
      timeout: 1000 * 60 * 5
  };


  return orignAxios.get(_url, {params: _params}, config);

};
Vue.prototype.$ChunkDownload = function (_url, _params, _fileid, _startindex, _total, _progress, _successfinish, _fail) {

  var chunkdownload = (chunkslice, index) => {

      let config = {
          headers: {
              //'Content-Type': 'multipart/form-data;boundary=---------------' + new Date().getTime(),
              'Authorization': `Bearer ${store.getters.access_token}`,
              'Content-Type': 'multipart/form-data'
          }
      };
      return new Promise((resolve, reject) => {
          let param = NeizhenUtil.isEmpty(_params) ? {} : NeizhenUtil.deepClone(_params);
          param.fileid = _fileid;
          param.index = index;
          orignAxios.post(_url, param, config).then(resp => {
              if (resp.data) {
                  resolve(resp.data);
              } else {
                  reject(resp.data);
              }

          }).catch(error => {
              reject(error);
          });

      })

  };

};

Vue.prototype.$DownLoad = function (_url, _param,resolve, reject) {
  let config = {
      headers: {
          //'Content-Type': 'multipart/form-data;boundary=---------------' + new Date().getTime(),
          'Authorization': `Bearer ${store.getters.access_token}`,
          'Content-Type': 'application/octet-stream;charset=utf-8'

      },
      'responseType': 'blob'
  };

  orignAxios
      .post(_url, _param, config)
      .then(function (response) {
          var headers = response.headers;
          if(headers["content-disposition"]){
              var disposition = headers["content-disposition"];
              var fname = disposition.substr(disposition.indexOf("=") + 1, disposition.length - 1);

              var blob = new Blob([response.data], {type: headers['content-type']});
              var downloadElement = document.createElement('a');
              var href = window.URL.createObjectURL(blob); //创建下载的链接
              downloadElement.href = href;
              downloadElement.download = decodeURIComponent(fname).replace(new RegExp('"', 'g'), ''); //下载后文件名
              document.body.appendChild(downloadElement);
              downloadElement.click(); //点击下载
              document.body.removeChild(downloadElement); //下载完成移除元素
              window.URL.revokeObjectURL(href); //释放掉blob对象
              resolve(response)
          }else {
              resolve('')
          }
      })
      .catch(function (error) {
          this.$alert(error, "提示", {
              confirmButtonText: "确定",
              type: "warning"
          });
        });
};
Vue.prototype.$DownLoadL = function (_url, _param,resolve, reject) {
  let config = {
      headers: {
          //'Content-Type': 'multipart/form-data;boundary=---------------' + new Date().getTime(),
          'Authorization': `Bearer ${store.getters.access_token}`,
          'Content-Type': _url != 'gxdl/bpmn/batchDownloadAttach' ? 'application/octet-stream;charset=utf-8' : 'application/json',
          "token":  window.sessionStorage.bpmnSid
      },
      'responseType': 'blob'
  };

  orignAxios
      .post(_url, _param, config)
      .then(function (response) {
          var headers = response.headers;
          if(headers["content-disposition"]){
              var disposition = headers["content-disposition"];
              var fname = disposition.substr(disposition.indexOf("=") + 1, disposition.length - 1);

              var blob = new Blob([response.data], {type: headers['content-type']});
              var downloadElement = document.createElement('a');
              var href = window.URL.createObjectURL(blob); //创建下载的链接
              downloadElement.href = href;
              downloadElement.download = decodeURIComponent(fname); //下载后文件名
              document.body.appendChild(downloadElement);
              downloadElement.click(); //点击下载
              document.body.removeChild(downloadElement); //下载完成移除元素
              window.URL.revokeObjectURL(href); //释放掉blob对象
              resolve(response)
          }else {
              resolve('')
          }
      })
      .catch(function (error) {
          reject(error);
          // this.$message.error('下载出错,请稍后重试')
      });

};
Vue.prototype.$mask = function (dom) {
  // debugger
  let color = "rgba(0, 0, 0, 0.1)";
  if (typeof (dom) == "undefined") {
      dom = document.querySelector("body");
      color = "rgba(0, 0, 0, 0.1)";
  }
  let loadingInstance = Loading.service({
      lock: true,
      background: color,
      target: dom//document.querySelector(dom)
  });

  return loadingInstance;
};

Vue.prototype.$Promise = function (metadata, _params, stringfy) {
  var lasturl = "/admin";
  if (metadata.restful == null || metadata.restful == false) {
      lasturl += metadata.url;
  } else {

      let restfulparams = metadata.restfulparams;
      lasturl += metadata.url;
      restfulparams.forEach((value, index) => {
          lasturl += "/" + params[value];
      });
  }

  let config = {
      headers: {
          //'Content-Type': 'multipart/form-data;boundary=---------------' + new Date().getTime(),
          'Authorization': `Bearer ${store.getters.access_token}`
      }
  };

  return new Promise((resolve, reject) => {
      orignAxios({
          url: lasturl,
          method: metadata.type,
          data: stringfy ? qs.stringify(_params, {indices: false}) : _params,
          config: config
      }).then((resp) => {
          resolve(resp);
      }).catch((error) => {
          reject(error);
      })
  });

};

//html,txt文件预览
import Editor from 'vue2-ace-editor'
Vue.component('editor', Editor)

Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
